import Browser from "./hooks/Browser";

/**
 * This component is developed to render typing area with browser autocomplete feature built-in
 */
export default class AutoComplete {
    constructor(options) {
        if (options) {
            this.name_mapping = {
                name: 'name',
                fname: 'given-name',
                mname: 'additional-name',
                lname: 'family-name',
                email: 'email',
                phone: 'tel',
                mobile: 'tel',
                region: 'region'
            };
            this.context = options.context || document;
            this.type = options.type || 'name';
            this.autocomplete = this.name_mapping[options.type];
            this.css = options.className;
            this.id = options.id;
            this.name = options.name || this.type;
            this.placeholder = options.placeholder || 'Please type here';
            this.parent =
                this.context.querySelector(options.containerSelector) || this.context.body;
            this.initialTag = options.autoCompleteInputType || 'INPUT';
            this.secTag = options.typingInputType || 'TEXTAREA';
            this.triggerEvent = options.eventType || 'keydown';
            this.input = options.inputSelector
                ? this.context.querySelector(options.inputSelector)
                : this.context.createElement(this.initialTag);
            this.textarea = options.textareaSelector
                ? this.context.querySelector(options.textareaSelector)
                : this.context.createElement(this.secTag);
            this.frmAutocomplete = this.context.querySelector('#frmAutocomplete');
            this.inputLenght = options.inputLenght || 30;
            this.enableAutoComplete = options.enableAutoComplete || 'on';
            this.makeInputAutoComplete.call(this);
            // coloring the inputs for debuging purpose
            // if (this.input) {
            //     this.input.style.backgroundColor = "blue";
            // }
            // if (this.textarea) {
            //     this.textarea.style.backgroundColor = "red";
            // }
            // register keyup on both elements
            if (this.input) {
                // null handle check
                this.bind.call(this, this.input);
                // show/hide on first render
                this.toggle.call(this, this.input, true); // show INPUT
            }
            if (this.textarea) {
                // null handle check
                this.bind.call(this, this.textarea);
                // show/hide on first render
                this.toggle.call(this, this.textarea, false); // hide TEXTAREA
            }
            if (this.enableAutoComplete === 'off') {
                this.toggle.call(this, this.input, false);
                this.toggle.call(this, this.textarea, true);
            }
            if (this.frmAutocomplete) {
                // null handle check
                this.frmAutocomplete.addEventListener('submit', (e) => {
                    e.preventDefault();
                    return false;
                });
            }
        }
    }
    // as per specifications, name attribute vs autocomplete attribute mapping

    /**
     * set Auto Complete attributes and classes
     */
    makeInputAutoComplete() {
        // el.id = this.id;
        if (!this.input) {
            return;
        }
        this.input.className += ` ${this.css}`;
        this.input.name = this.name;
        this.input.type = 'text';
        this.input.autocomplete = this.enableAutoComplete;
        this.input.placeholder = this.placeholder;
    }

    /**
     *
     * @param {el} element
     * @param {show} show hide element base on condition
     * @param {val} update element value
     */
    toggle(el, show, val) {
        if (!el) {
            return;
        }
        if (show) {
            el.style.display = 'block';
            if (!Browser.isiOS()) {
                el.focus();
            }
        } else {
            el.style.display = 'none';
        }
        if (el.nodeName == 'TEXTAREA') {
            this.frmAutocomplete.style.display = show ? 'none' : 'block';
        }
        el.value = val || '';
    }

    /**
     * the dynamic element must check on keyup and toggle when it empties out
     */
    bind(el) {
        const me = this;
        el.addEventListener(me.triggerEvent, (e) => {
            if (/iPad|iPhone|iPod/.test(navigator.userAgent) || Browser.isAndroid()) {
                // do not toggle the inputs in iOs case because it will create flickring effect
                return;
            }
            if (me.input.value.length >= me.inputLenght) {
                // if input lenght greater than config length then text area shown
                if (me.textarea) {
                    // null handle check
                    this.toggle.call(me, me.textarea, true, el.value);
                }
                if (me.input) {
                    // null handle check
                    this.toggle.call(me, me.input, false, el.value); // update input
                }
            } else {
                if (me.textarea) {
                    // null handle check
                    this.toggle.call(me, me.textarea, false, el.value);
                }
                if (me.input) {
                    // null handle check
                    this.toggle.call(me, me.input, true, el.value);
                }
            }
        });
    }
}
